import { Component, OnInit, Input } from '@angular/core';
import { ComponentOnSystemViewModel } from '../../action-models';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActionService } from '../../action.service.service';
import { TranslateService } from '../../../../translate';
import { ComponentDetails } from '../../../../modules/manage-equipment/models/manage-equipment.model';

import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
@Component({
  selector: 'component-action-view',
  templateUrl: './component-action-view.component.html',
  styleUrls: ['./component-action-view.component.scss'],
  animations: [
   // trigger('fadeInList', [
   //   transition('* => *', [
   //     query(':enter', style({ opacity: 0 }), { optional: true }),
   //     query(':enter', stagger('500ms', [
   //       animate('.5s ease-in', keyframes([
   //         style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
   //         style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
   //       ]))]), { optional: true })
   //   ])
   // ]),
   // trigger('listAnimation', [
   //   transition('* => *', [
   //     query(':enter', style({ opacity: 0 }), { optional: true }),
   //     query(':enter', stagger('500ms', [
   //       animate('.5s ease-in', keyframes([
   //         style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
   //         style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
   //       ]))]), { optional: true })
   //   ])
   // ]),
   trigger(
     'fadeIn', [
       transition(':enter', [
         style({ opacity: 0 }),
         animate('500ms', style({ opacity: 1 }))
       ]),
       transition(':leave', [
         style({ opacity: 1 }),
         animate('500ms', style({ opacity: 0 }))
       ])
     ]
   )
 ],
})
export class ComponentActionViewComponent implements OnInit {

  @Input() component: ComponentOnSystemViewModel;
  userLanguage = 'English';


  loading = false;
  componentToDisplay: ComponentDetails;

  loadingComponent = false;
  constructor(
    private _sanitizer: DomSanitizer,
    private _loadingService: LoadingService,
    private _actionService: ActionService,
    private _translate: TranslateService) { }

  ngOnInit() {
    this._actionService.getComponentActionView(this.component.GeneralEqunitId).subscribe(c => {
        this.componentToDisplay = c;
      });
  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

}
